export const recordEntries = (record) => Object.entries(record);
//# sourceMappingURL=records.js.map